export default __webpack_public_path__ + "static/rebecca2-1d4b2b244ce785b7bac6fae5b30d6fb0.jpg";